/* The Aesthetic Cove — Gifts by budget.
   The price tags are tabs: click one (or use the arrow keys, Home and End)
   and its products swing in. Any [data-tiers] block (a smaller set of price
   chips) is wired the same way. Without this script the opening tag's
   products show and each "See all" link still works. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const wire = (tabs) => {
    if (!tabs.length) return;
    const panelOf = (tab) => document.getElementById(tab.getAttribute('aria-controls'));

    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        const panel = panelOf(t);
        if (!panel) return;
        panel.hidden = !on;
        panel.classList.remove('is-entering');
        if (on && !reduce) {
          void panel.offsetWidth;
          panel.classList.add('is-entering');
        }
      });
      if (focus) tab.focus();
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (e) => {
        let next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        e.preventDefault();
        select(next, true);
      });
    });
  };

  document.querySelectorAll('[data-budget]').forEach((band) => {
    if (band.dataset.ready) return;
    band.dataset.ready = '1';
    wire(Array.from(band.querySelectorAll('.budget__tags [role="tab"]')));
    band.querySelectorAll('[data-tiers]').forEach((tiers) => {
      wire(Array.from(tiers.querySelectorAll('.tiers__switch [role="tab"]')));
    });
  });
})();
